import type * as lazyIndex from './lazyIndex';
import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';

import {
    itemPartSelected,
    rangeSelectItemPart,
} from 'owa-mail-actions/lib/mailListSelectionActions';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName:"MailListSelectionActionsV2" */ './lazyIndex'),
    { name: 'mail/packages/mail/orchestration/owa-mail-list-selection-actions-v2' }
);

registerLazyOrchestrator(rangeSelectItemPart, lazyModule, m => m.rangeSelectItemPartOrchestrator);
registerLazyOrchestrator(itemPartSelected, lazyModule, m => m.itemPartSelectedOrchestrator);

// Import orchestrators and mutators so they get registered
import './orchestrators/initTableSelectionOnLoadOrchestrator';
import './orchestrators/keyboardMultiSelectRowOrchestrator';
import './orchestrators/rangeSelectRowOrchestrator';
import './orchestrators/resetSelectionOrchestrator';
import './orchestrators/selectNewItemUponRowRemovalOrchestrator';
import './orchestrators/selectRowInDirectionOrchestrator';
import './orchestrators/singleSelectRowOrchestrator';
import './orchestrators/toggleSelectAllRowsOrchestrator';
import './orchestrators/toggleSelectRowOrchestrator';

import './mutators/resetSelectionOnTableMutator';
import './mutators/setSelectionOnRowMutator';
import './mutators/updateCheckedStateOfConversationChildren';

export { setLastAutoFocusedRowKey } from './mutators/setLastAutoFocusedRowKey';
export { setRowKeyPendingSelectionMutator } from './mutators/setRowKeyPendingSelectionMutator';
export { default as updateCheckedStateOfConversationChildren } from './mutators/updateCheckedStateOfConversationChildren';
export { deactivateSRPForContextMenu } from './utils/deactivateSRPForContextMenu';
